import { Fragment, useContext } from "react";
import DataContext from "../../context/data-context";
import poshBkg from "../../assets/img/posh-bg.webp";

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

import NavigationBar from "./NavigationBar";
import LoadingSpinner from "../UI/LoadingSpinner";

export default function Layout({ children }) {
  const { loadingData } = useContext(DataContext);

  return (
    <div className="bg-gradient-to-br from-stone-900">
      <div className="min-h-screen lg:h-screen">
        <img
          className="fixed top-0 left-0 object-cover w-screen h-screen -z-10"
          src={poshBkg}
        />
        <Navbar />
        <NavigationBar />
        <div className="grid gap-4 mx-2 lg:gap-2 md:grid-cols-6">
          <Sidebar />
          <div className="md:col-span-5">
            {loadingData ? <LoadingSpinner /> : children}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
